import axios from 'axios';
import { useStore } from '../../../store';
import { showMoreCheckout } from './showMoreCheckout';
import { getNews } from './getNews';
import { resetNews } from './resetNews';
import { getUrl } from './getUrl';

const store = useStore();

export const filter = (val) => {
    if (store.state.press.filterCode !== val) {
        resetNews();
    }

    if (val === '') {
        store.commit('press/CHANGE_FILTER', val);
        resetNews();
        getNews();
    }
    else {
        store.commit('press/SET_LOADING', true);
        store.commit('press/CHANGE_FILTER', val);
        let url = getUrl();

        axios.get(url)
            .then(res => {
                showMoreCheckout(res.data.meta.totalPages);
                const articles = !store.state.press.news.length ? res.data.data : [...store.state.press.news, ...res.data.data];
                store.commit('press/SET_NEWS', articles);
                store.commit('press/SET_LOADING', false);
            })
    }
}
